// extracted by mini-css-extract-plugin
module.exports = {"table-wrapper":"Table_table-wrapper__PyV2x","table":"Table_table__GgPcK"};